// @todo: maybe we could replace this with a library that creates a slug of a string.
export default function (string: string): string {
  return string && string.toLowerCase().replace(/ +/g, '-');
}
